export default __webpack_public_path__ + "static/media/elpoB.2144b4ac.png";